import { render, staticRenderFns } from "./CounterView.vue?vue&type=template&id=2d479c49&scoped=true"
import script from "./CounterView.vue?vue&type=script&lang=js"
export * from "./CounterView.vue?vue&type=script&lang=js"
import style0 from "./CounterView.vue?vue&type=style&index=0&id=2d479c49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d479c49",
  null
  
)

export default component.exports